import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useHttpClient } from '@/shared/api/http-client-context'
import { notificationInboxQueryKeys } from './notification-inbox-query-keys'
import {
  fetchInAppNotifications,
  fetchUnreadNotificationCount,
  markAllNotificationsRead,
  markNotificationRead,
} from './notifications-api'

const recentPageSize = 8

export function useUnreadNotificationCountQuery(tenantId: string) {
  const client = useHttpClient()
  return useQuery({
    queryKey: notificationInboxQueryKeys.unread(tenantId),
    queryFn: () => fetchUnreadNotificationCount(client),
    enabled: tenantId.length > 0,
  })
}

export function useInAppNotificationsQuery(tenantId: string) {
  const client = useHttpClient()
  return useQuery({
    queryKey: notificationInboxQueryKeys.list(tenantId),
    queryFn: () => fetchInAppNotifications(client, { page: 1, pageSize: recentPageSize }),
    enabled: tenantId.length > 0,
  })
}

function invalidateInbox(qc: ReturnType<typeof useQueryClient>, tenantId: string) {
  void qc.invalidateQueries({ queryKey: notificationInboxQueryKeys.unread(tenantId) })
  void qc.invalidateQueries({ queryKey: notificationInboxQueryKeys.list(tenantId) })
}

export function useMarkNotificationReadMutation(tenantId: string) {
  const client = useHttpClient()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (notificationId: string) => markNotificationRead(client, notificationId),
    onSettled: () => invalidateInbox(qc, tenantId),
  })
}

export function useMarkAllNotificationsReadMutation(tenantId: string) {
  const client = useHttpClient()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => markAllNotificationsRead(client),
    onSettled: () => invalidateInbox(qc, tenantId),
  })
}
